/**
 * A reply as plain words. The AI backend's model writes markdown by habit
 * and escapes what markdown would otherwise read - `\$20`, `\_`, `\*` -
 * but nothing here renders markdown: a bubble shows the text as it is, so
 * a visitor was reading "\$20 total to get started" (2026-10-06). The
 * backslash before a markdown punctuation mark is dropped; everything else
 * is kept as written. A backslash that escapes a backslash is left alone,
 * so running this over text already cleaned changes nothing.
 */
export function plainTextOfReply(text: string): string {
  // An escaped backslash is matched first and kept whole, so the backslash
  // it protects can never be read as escaping what follows it.
  return text.replace(/\\\\|\\([`*_{}[\]()#+\-.!|>~$])/g, (match, mark) =>
    mark === undefined ? match : mark
  )
}
